import {Component, OnInit, OnChanges, SimpleChange, Input, Output, EventEmitter} from '@angular/core';
import {HelperService} from "../../services/helper.service";

@Component({
  selector: 'attachment-upload',
  templateUrl: './attachment-upload.component.html',
  styleUrls: ['./attachment-upload.component.scss']
})
export class AttachmentUploadComponent implements OnInit,OnChanges {

  files: File[] = [];
  attachments:any = [];
  @Input() fileChanges: number;
  @Output() submited = new EventEmitter<any>();
  count:number = 0;
  constructor(private helperService:HelperService) { }

  ngOnInit() {
  }

  ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
    let log: string[] = [];
    for (let propName in changes) {
      let changedProp = changes[propName];
      let to = JSON.stringify(changedProp.currentValue);
      if (changedProp.isFirstChange()) {
        log.push(`Initial value of ${propName} set to ${to}`);
      } else {
        let from = JSON.stringify(changedProp.previousValue);
        log.push(`${propName} changed from ${from} to ${to}`);
        this.submit();
      }
    }
  }

  onSelect(event) {
    //console.log(event);
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    //console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }

  submit(){
    if(this.files.length == 0){
    //  this.submited.emit(this.attachments);
    }else {
      const that = this;
      let reader = 0;
      that.attachments = [];
      for (let i = 0; i < this.files.length; i++) {
        this.helperService.readFile(this.files[i]).then(fileContents => {
          reader = reader + 1;
          // Put this string in a request body to upload it to an API.
          let tem = this.files[i];
          let parts = tem.name.split('.');
          let data = {
            name: tem.name,
            size: tem.size,
            type: tem.type,
            extension: parts[parts.length - 1],
            file: fileContents
          };
          that.attachments.push(data);
          if (reader == (this.files.length)) {
            this.submited.emit(this.attachments);
          }
          //console.log(fileContents);
        });
      }
    }
  }


}



// WEBPACK FOOTER //
// /app/src/app/attachment/attachment-upload/attachment-upload.component.ts